module.exports = __webpack_public_path__ + "img/location.af72f58e.svg";